import React from 'react';

import SVGLogo from './svgLogo';

const LinkLogo = (props) => {
  const { appType, LinkComponent } = props;
  let linkProps = {
    to: '/',
    className: 'wisedoc-logo',
  };
  if (appType === 'CRA') {
    linkProps = {
      to: '/drive/myDrive',
      className: 'wisedoc-logo',
    };
  }
  if (appType === 'CRA') {
    linkProps = {
      ...linkProps,
      'data-testId': 'wisedoc-logo',
      'aria-label': 'wisedoc-logo',
    };
  } else if (appType === 'GATSBY') {
    linkProps = {
      ...linkProps,
      dataTestId: 'wisedoc-logo',
    };
  }

  return (
    <>
      {LinkComponent && (
        <LinkComponent {...linkProps}>
          <SVGLogo {...props} />
        </LinkComponent>
      )}
    </>
  );
};

export default LinkLogo;
